import type { HTMLProps } from "react";

import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export const LogoButton = ({
    children,
    type,
    ...rest
}: HTMLProps<HTMLButtonElement>) => {
    const modalVisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );
    const socialButtonLinks = checkFeatureFlagGate(
        featureFlags.a11yAccountCreationSocialButtonLinks
    );
    return (
        <button
            css={[logoButtonCss, modalVisualUpdates && logoButtonCssV2]}
            type="button"
            role={socialButtonLinks ? "link" : undefined}
            {...rest}
        >
            {children}
        </button>
    );
};

const logoButtonCss = css({
    alignItems: "center",
    backgroundColor: token("elevation.surface"),
    border: `1px solid ${token("color.border")}`,
    borderRadius: 21,
    color: token("color.text"),
    cursor: "pointer",
    display: "flex",
    fontFamily: "inherit",
    fontSize: "inherit",
    gap: "0.5rem",
    height: "40px",
    justifyContent: "center",
    padding: "0.5rem 0.75rem",
    width: "100%",
    ["&:focus, &:hover"]: {
        backgroundColor: token("elevation.surface.hovered")
    },
    ["&:focus-visible"]: {
        "outline-offset": 1
    }
});

// todo remove !important when we productionize gate and merge properties with logoButtonCss
const logoButtonCssV2 = css({
    color: `${token("color.text.subtle")} !important`
});
